import React, { useState, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createBookDemoLead } from '../../api/utils';
import { Toast } from 'bootstrap'; 

const BookDemoForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    studentClass: '',
    course: '',
    phone: '',
    message: '',
  });
  const toastRef = useRef(null);
  const [show, setShow] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

  const handleBookDemo = async () => {
    const { name, email, studentClass, course, phone, message } = formData;

    if (!name || !email || !studentClass || !course || !phone || !message) {
      alert('Please fill in all fields before submitting.');
      return;
    }
    formData['stage'] = 'book_demo'
    const response = await createBookDemoLead(formData);
    if (response.status === true && toastRef.current) {
      const toast = new Toast(toastRef.current);
      toast.show();
    }
    handleClose();
  };

  return (
    <>
        {/* Left Text */}
        <div className="col-md-6 text-center text-md-start px-5">
          <h1 className="fw-bold text-grey">Book a Free<br />
          <span className='text-warning'>Demo Now</span></h1>
          <p className="text-muted mt-3">
            Please fill out the enquiry form to get in touch with us.
            <br />
            Our top career oriented counsellors will be really happy to help you.
          </p>
        </div>

        <div className="col-md-6 d-flex justify-content-center">
          <div className="card p-4 rounded-4 shadow" style={{ maxWidth: '500px', width: '100%' }}>
            <form onSubmit={(e) => { e.preventDefault(); handleBookDemo(); }}>
              <div className="mb-3">
                <label className="form-label fw-semibold">Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Full Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">E-mail</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter E-mail ID"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label fw-semibold">Class</label>
                  <select
                    className="form-select"
                    name="studentClass"
                    value={formData.studentClass}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select</option>
                    <option value="6th">6th</option>
                    <option value="7th">7th</option>
                    <option value="8th">8th</option>
                    <option value="9th">9th</option>
                    <option value="10th">10th</option>
                    <option value="11th">11th</option>
                    <option value="12th">12th</option>
                  </select>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label fw-semibold">Course</label>
                  <select
                    className="form-select"
                    name="course"
                    value={formData.course}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select</option>
                    <option value="SCHOOL">School</option>
                    <option value="JEE">JEE</option>
                    <option value="NEET">NEET</option>
                    <option value="Boards">Boards</option>
                    <option value="SAT">SAT</option>
                  </select>
                </div>
                
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">Phone No.</label>
                <div className="input-group">
                  <span className="input-group-text">+966</span>
                  <input
                    type="tel"
                    className="form-control"
                    placeholder="Mobile Number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">Message</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Type your message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="primary-button btn-lg btn btn-primary w-100 rounded-pill mt-2">
                Submit
              </button>
            </form>
          </div>
        </div>
        <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 11 }}>
          <div
            ref={toastRef}
            className="toast align-items-center text-bg-success border-0"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          >
            <div className="d-flex">
              <div className="toast-body">Sit Tight! Someone from Our team will call you Soon.</div>
              <button
                type="button"
                className="btn-close btn-close-white me-2 m-auto"
                data-bs-dismiss="toast"
                aria-label="Close"
              ></button>
            </div>
          </div>
        </div>
    </>
  );
};

export default BookDemoForm;
